import { instance } from './index';
var PREFILL_URL = '/widget/prefill';
export var PREFILL_ERROR_MESSAGE = 'We could not load your saved application data. Please refresh and try again.';
var get = function (_a) {
    var prefillId = _a.prefillId;
    return instance({
        method: 'GET',
        url: "".concat(PREFILL_URL, "/").concat(prefillId)
    });
};
export var extractApplicationFormData = function (data, expectedExternalCustomerID) {
    var externalCustomerID = data.externalCustomerID, applicationFormData = data.applicationFormData;
    if (externalCustomerID !== expectedExternalCustomerID) {
        throw new Error('Prefill data customer does not match the customer from the widget config. Please review your configuration and try again.');
    }
    if (!applicationFormData ||
        typeof applicationFormData !== 'object' ||
        Array.isArray(applicationFormData) ||
        Object.keys(applicationFormData).length === 0) {
        throw new Error('Invalid prefill payload');
    }
    return applicationFormData;
};
export default { get: get };
